import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function VwTopMenuItems (props){

    const view = "VwTopMenuItems";

    const { onSearchInitialized, apiInitialized, onInitialized, onLoadData } = props;

    const [ api, setApi ] = useState ( null );

    useEffect ( () => {

        if (api ) {

            api.refresh ();

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ api ] );

    const onApiInitialized = ( api ) => {

        if(apiInitialized) {
            apiInitialized(api)
        } 

        setApi ( api );

    };

    const onGridInitialized = ( grid ) => {
        grid.selectionMode = "Row";
        onInitialized(grid)
    };

    return (
    
        <BasicCrudScreenType
            id="VwTopMenuItems"
            noHeader
            view={view}
            onApiInitialized={onApiInitialized}
            onSearchInitialized={onSearchInitialized}
            onInitialized={onGridInitialized}
            onLoadData = {onLoadData}
        />

    );

}
export default VwTopMenuItems;